import { createAction } from "@reduxjs/toolkit";

const setDate = createAction("calendar/setDate");

export default setDate;
